import * as React from 'react'

type AnyFunction = (...args: any[]) => any

export interface ReduxFormProps {
  handleSubmit?: (values: any) => void
}

export type GetProps<T> = T extends React.ComponentClass<
  infer ComponentClassProps
>
  ? ComponentClassProps
  : T extends React.SFC<infer StatelessComponentClassProps>
    ? StatelessComponentClassProps
    : never

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>

export type StringToNumber = {
  [k: string]: number
  0: 0
  1: 1
  2: 2
}

export type Argument<
  N extends StringToNumber[keyof FnShape<any>],
  T extends FnShape<any>[N]
> = T extends FnShape<infer R>[N] ? R : T

interface FnShape<N> {
  0: (a0: N, ...args: any[]) => any
  1: (a0: any, a1: N, ...args: any[]) => any
  2: (a0: any, a1: any, a2: N, ...args: any[]) => any
  [i: number]: AnyFunction
}

export type GetChildrenProp<T> = GetProps<T> extends { children: infer R } ? R : never

type ChildrenRenderPropHelper<X> = X extends AnyFunction ? Argument<0, X> : never

export type GetChildrenRenderProp<T> = ChildrenRenderPropHelper<GetChildrenProp<T>>

type MutationRenderProps<T extends (...args: any[]) => any> = { mutate: Argument<0, T>, data: Argument<1, T> }
type MutationRenderPropsHelper<X> = X extends AnyFunction ? MutationRenderProps<X> : never

export type GetMutationRenderProp<T> = MutationRenderPropsHelper<GetChildrenProp<T>>

export enum UserRole {
  ADMIN = 'ADMIN',
  USER = 'USER'
}

export enum IntervalType {
  ANNUALY = 'ANNUALY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY'
}



// WEBPACK FOOTER //
// ./src/types.tsx